import { render, staticRenderFns } from "./IdentifierDetails.vue?vue&type=template&id=889dc36e"
import script from "./IdentifierDetails.vue?vue&type=script&lang=js"
export * from "./IdentifierDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports